import { FrameModules } from 'Shared/frame_modules';
import NewsLetter from 'Shared/newsletter';

FrameModules.add('NewsletterFrameModule', function () {
   new LegacyNewsLetter();
});

class LegacyNewsLetter extends NewsLetter {
   constructor() {
      const newsletterDiv = document.querySelector('#newsletterFooterDiv');
      super(newsletterDiv);
   }

   _getEl() {
      return this.el;
   }

   _getIconEl() {
      return document.querySelector('#newsletterIcon');
   }

   _getTextEl() {
      return document.querySelector('#newsletterText');
   }

   _getEmailEl() {
      return document.querySelector('#newsletterEmailInput');
   }

   _getForm() {
      return document.querySelector('#newsletterForm');
   }

   _getEmailSuccessIcon() {
      return 'fa fa-check-circle';
   }

   _getEmailErrorIcon() {
      return 'fa fa-times';
   }

   _getRecaptchaKey() {
      return this._getForm().get('data-sitekey');
   }

   _getRecaptchaPlaceholder() {
      return document.querySelector('#newsletter-recaptcha');
   }
}
